import { graphql } from 'src/graphql';

import { TeamFields } from 'src/fragments/teamFields.fragment';

export const FetchUsersByTeamId = graphql(
  `
    query FetchUsersByTeamId($_id: ID) {
      teamById(_id: $_id) {
        ...TeamFields
      }
    }
  `,
  [TeamFields],
);
